"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importDefault(require("react"));

const styles_1 = require("@mui/material/styles");

const material_1 = require("@mui/material");

const muiTheme = (0, styles_1.createTheme)((0, material_1.adaptV4Theme)({
  palette: {
    primary: {
      light: "#00b3ea",
      main: "#00A9E0",
      dark: "#0091c8",
      contrastText: "#fff"
    },
    secondary: {
      main: "rgba(0, 0, 0, 0.54)"
    },
    error: {
      main: "#ff3333",
      contrastText: "#fff"
    },
    neutral: {
      main: "rgba(50, 50, 50, 1)",
      dark: "rgba(59, 135, 62, 1)",
      light: "rgba(189, 189, 189, 1)",
      contrastText: "rgba(255, 255, 255, 1)"
    },
    action: {
      active: "rgba(0, 0, 0, 0.54)",
      selected: "rgba(0, 0, 0, 0.08)",
      hover: "rgba(0, 0, 0, 0.04)"
    }
  },
  overrides: {
    MuiInput: {
      underline: {
        "&:before": {
          //underline color when textfield is inactive
          borderBottom: "1px solid #DDDDDD"
        },
        "&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error):before": {
          //underline color when hovered
          borderBottom: "2px solid #DDDDDD"
        }
      }
    },
    MuiFormLabel: {
      root: {
        fontWeight: "normal"
      }
    },
    MuiInputLabel: {
      root: {
        fontWeight: "normal"
      }
    },
    MuiCollapse: {
      entered: {
        height: "auto",
        overflow: "visible"
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: 24
      }
    },
    MuiRadio: {
      root: {
        padding: 12
      }
    },
    MuiCheckbox: {
      root: {
        padding: 12
      }
    },
    MuiTypography: {
      body1: {
        color: "rgba(0, 0, 0, 0.87)"
      }
    },
    MuiTableRow: {
      root: {
        "&.Mui-selected": {
          backgroundColor: "rgba(0, 169, 224, 0.08)",
          "&:hover": {
            backgroundColor: "rgba(0, 169, 224, 0.08)"
          }
        }
      }
    },
    MuiButton: {
      outlinedSecondary: {
        color: "rgba(0, 0, 0, 0.87)",
        borderColor: "rgba(0, 0, 0, 0.23)"
      },
      containedSecondary: {
        color: "rgba(0, 0, 0, 0.87)"
      }
    },
    MuiToggleButton: {
      sizeSmall: {
        "&.Mui-selected": {
          color: "rgba(0, 0, 0, 0.54) !important"
        }
      }
    }
  },
  spacing: factor => `${8 * factor}px`
}));

function SskyMuiTheme(props) {
  return react_1.default.createElement(styles_1.ThemeProvider, {
    theme: muiTheme
  }, props.children);
}

exports.default = SskyMuiTheme;
;